/*路由语言*/
// src/locales/zh-CN.js

export default {
  //路由语言
  'home.title': 'CTM sees the world',
  'detail.title': 'details',
  'shareDetail.title': 'share page',
  'filter.title': 'filter',
  'special.title': 'topic',
  'search.title': 'search',
  'activity.title': 'activity',
  //首页语言
  'home.page.more': 'more',
  'home.page.hot': 'Hot Recommendations',
  'home.page.good': 'hottest and latest',

  //搜索页语言
  'search.page.cancel': 'cancel',
  'search.page.placeholder': 'Please try another keyword again.',
  'search.page.searchToast1': 'No related content is found',
  'search.page.searchToast2': 'Please try it again',
  'search.page.searchhistory': 'search history',
  'search.page.hotSearch': 'Top Search',
  'filter.page.failToast': 'No filter results',
  'search.page.address': 'region',
  'search.page.act': 'starring',
  'search.page.from': 'source',
  'search.page.year': 'year',
  'search.page.mangguo': 'Mango TV',
  'search.page.hmvod': 'HMVOD',

  //详情语言
  'detail.page.share': 'share',
  'detail.page.summary': 'introduction',
  'detail.page.selection': 'anthology',
  'detail.page.selections': 'All anthology',
  'detail.page.recommend': 'Recommedation',
  'detail.page.err': 'Encounter a problem',
  'detail.page.3001': 'This film requires purchase',
  'datail.page.orderButton': 'Subscribe now',
  'detail.page.watchingHorror': 'Watch the main film',
  'detail.page.scanQR':
    'Please scan the QR code to download the client to watch',
  'detail.page.Android': 'Android download',
  'detail.page.IOS': 'IOS download',
  'detail.page.next': 'Play Next',
  'detail.page.age': 'age',
  'detail.page.Playability': 'Playability',
  'detail.page.Players': 'Players',
  'detail.page.Availability': 'Availability',
  'detail.page.ReadMore': 'Read more',
  'detail.page.PlayGame': 'Play game',

  //播放器提示语言
  'video.page.vodFailToast':
    'This asset is not playable, try it with another asset',

  // 收藏
  'collect.page.myCollect': 'My Favourite(s)',
  'collect.page.view': 'Recent View',
  'collect.page.viewRecord': 'View History',
  'collect.page.noView': 'No recent views',
  'collect.page.noCollect': 'No collection record',
  'collect.page.clear': 'Clear All',
  'collect.page.collect': 'collect',
  'collect.page.cancelCollect': 'cancel collection',
  'collect.page.movie': 'movie',
  'collect.page.series': 'TV series',
  'collect.page.news': 'information',
  'collect.page.column': 'synthetic type',
  'collect.page.category': 'topic',
  'collect.page.today': 'Today',
  'collect.page.yesterday': 'Confirmterday',
  'collect.page.beforeYesterday': 'The day before Confirmterday',
  'collect.page.earlier': 'Earlier',
  'collect.page.part': 'part',
  'collect.page.clearView': 'Confirm clear recent views',
  'collect.page.clearCollect': 'Confirm clearing collection records',
  'collect.page.clearSuccess': 'Record cleared successfully',
  'collect.page.oneClearSuccess': 'Cancelled',
  'collect.page.oneCollectSuccess': 'Added to Favourite(s)',
  'collect.page.CollectSpecial': 'Favourite(s)',

  // 个人中心
  'profile.page.profile': 'Me',
  'profile.page.cut': 'Switch Account',
  'profile.page.logout': 'log out account',
  'profile.page.login': 'Log in now',
  'profile.page.bill': 'Bill',
  'profile.page.equity': 'Rights',
  'profile.page.download': 'Download on mobile',
  'profile.page.lang': 'Language',
  'profile.page.patriarch': 'Parental Control',
  'profile.page.type': 'Category',
  'profile.page.title': 'Name',
  'profile.page.time': 'order time',
  'profile.page.payTime': 'Subscription Time',
  'profile.page.validTime': 'Validity',
  'profile.page.price': 'Subscription Price',
  'profile.page.none': 'No data',
  'profile.page.open': '(turned on)',
  'profile.page.closed': '(closed)',
  'profile.page.mumber': 'member',
  'profile.page.ticket': 'movie ticket',
  'profile.page.Tip1':
    ' Note: The membership of the monthly fee payment is valid until the cancellation of the service',

  // 登陸
  'login.page.phone': 'Login with Mobile No.',
  'login.page.verify': 'Go for verification ',
  'login.page.qrcode':
    'Please use the CTM Home Media mobile app to scan the code to log in',
  'login.page.back': 'Back',
  'login.page.sureLogin': 'confirm login',
  'login.page.verification':
    'Please enter the verification code to complete login/registration',
  'login.page.check': 'security check',
  'login.page.answer':
    'Please fill in the correct answer to complete the verification',
  'login.page.sure': 'confirm',
  'login.page.next': 'change one',
  'login.page.require': 'revalidate',
  'login.page.please': 'Please enter the correct phone number',
  'login.page.loginSuccess': 'login successful',
  'login.page.pleaseCode': 'Please enter ',
  'login.page.pleaseTrueCode': 'Please enter the correct captcha',
  'login.page.pleaseImgVerify': 'Please enter the image captcha result',
  'login.page.pleaseTrueImgVerify':
    'Please enter the correct image captcha result',
  'login.page.openordownload': 'Download/Open',
  'login.page.clickRight':
    'Click on the top right corner and select Open link in your browser',

  // 订购
  'order.page.QRpayType': 'Scan code payment platform',
  'order.page.QRtips':
    'Scan code payment tips: 1. The service will take effect immediately after successful payment; 2. The service plan is valid for 30 days in the first month',
  'order.page.QRpay': 'QR code payment',
  'order.page.paySuccess': 'Order successful',
  'order.page.paySuccess1':
    'Success, you have completed your subscription to membership benefits',
  'order.page.paySuccess2': 'Dear members, hello',
  'order.page.paySuccess3':
    'You can check the benefits you have ordered in the "My" Rights Center, and if you have any questions during the membership service, you can contact customer service 1000',
  'order.page.selfRecovery': 'automatically return after',
  'order.page.payfaile1': 'failed purchase',
  'order.page.payfaile2':
    'Sorry, there was a problem with the ordering process and the order failed',
  'order.page.warnCode': 'error code',
  'order.page.payfaile3': '1. Please select another program or try again',
  'order.page.payfaile4':
    ' 2. If none of the above methods can be solved, please call 1000 for consultation. ',
  'order.page.payfaile3005':
    'Your member benefits are being processed, if necessary, you can dial 1000 to contact customer services.',
  'order.page.payfaile3006':
    ' Your member benefits is being processed, please wait',
  'order.page.close': 'close',
  'order.page.getCode': 'Get Captcha',
  'order.page.getCodeAgain': 'Re-fetch captcha',
  'order.page.payVerify': 'Pay Verify',
  'order.page.billPay': 'mobile bill payment',
  'order.page.payCode': 'Pay Account',
  'order.page.order': 'order',
  'order.page.pleaseDuCode': 'Please enter',
  'order.page.pleaseID': 'Please enter',
  'order.page.InternetOrder': 'Internet Bill Pay',
  'order.page.pleaseDu': 'Please enter',
  'order.page.ID': 'Identity ID',
  'order.page.ordering': 'ordering, please wait',
  'order.page.WXPC': 'ICBC Macau - WeChat PC',
  'order.page.developing': 'in development',
  'order.page.purchaseType': 'Package type',
  'order.page.paymentType': 'Pay method',
  'order.page.viewService': 'Terms & Conditions',
  'order.page.Tip1': 'Purchase & agree to the above Terms & Conditions',
  'order.page.Tip2':
    'Terms and Conditions of the Service ("Terms and Conditions")',

  // 首页语言
  'home.page.lodin': 'You are logged in',
  'home.page.day': 'days',

  //  Toast
  'toast.page.processed':
    'The service you have requested is being processed, please try again later',

  // 筛选
  'filter.page.all': 'all',
  'filter.page.open': 'recently opened',
  'filter.page.collect': 'My Collection',

  // 家长管制
  'parent.page.set': 'Set Parental Control',
  'parent.page.num': 'account',
  'parent.page.code': 'Mobile Verification Code',
  'parent.page.setPassword': 'Set parental control password',
  'parent.page.pleasePIN': 'Please enter password',
  'parent.page.getCode': 'Get Verification Code',
  'parent.page.wrongPassword': 'password error',
  'parent.page.notice': 'note',
  'parent.page.Tip1':
    'The content of this item is potentially objectionable; You may not distribute, circulate, sell, rent, give or lend this item to persons under the age of 18 or to make available, play or show this item to such persons, subject to restrictions to continue viewing the content. ',
  'parent.page.verify': 'verify',
  'parent.page.close': 'Turn off parental controls',
  'parent.page.open': 'Turn on parental controls',
  'parent.page.onmsg': 'Parental control is on',
  'parent.page.offmsg': 'Parental control is off',
  'parent.page.pleaseOpen': 'Please turn on parental controls first',
  'parent.page.changePassword': 'change password',

  // HMOVD
  'hmovd.page.member': 'VIP',
  'hmovd.page.ticket': 'VOUCHER',
  'hmovd.page.use': 'this use',
  'hmovd.page.have': 'own',
  'hmovd.page.piece': 'piece',
  'hmovd.page.validity': 'expiry',
  'hmovd.page.Tip1': 'Insufficient tickets, need to buy tickets',
  'hmovd.page.Tip2':
    'Valid for 48 hours after purchase and use, can be revisited',
  'hmovd.page.Tip3':
    'All additional complimentary tickets valid until cancellation of the service',
  'hmovd.page.Tip4': 'Payment successful, please watch within 48 hours',
  'hmovd.page.exchange': 'redeem now',
  'hmovd.page.buy': 'buy now',
  'hmovd.page.surplus': 'movie ticket surplus',
  'hmovd.page.please': 'Please use the ticket to watch the content',
  'hmovd.page.need': 'Require purchase to watch',
  'hmovd.page.look': 'movie ticket view',
  'hmovd.page.purchase': 'buy',

  // live
  'live.page.allLive': 'All Live',
  'live.page.living': 'ON Air',
  'live.page.purchase': 'VIP',
  'live.page.otherLive': 'Other live streams',
  'live.page.tryWill': 'Try it will end after ',
  'live.page.end': 'minutes, full version please',
  'live.page.pay': 'Buy this film',
  'live.page.needPay': 'This live broadcast needs to be paid to watch',
  'live.page.payLook': 'Buy to watch',
  'live.page.from': 'Next Live at ',
  'live.page.liveAnd': ' Remaining',
  'live.page.hours': ' hour',
  'live.page.minutes': ' min',
  'live.page.seconds': ' sec',
  'live.page.liveEnd': 'OFF Air',
  'live.page.exitFullscreen': 'Exit Fullscreen',

  //mytv
  'mytv.page.playNow': 'Play Now',
  'mytv.page.firstTimeWatch':
    'First time watching myTV content requires adding an email account',
  'mytv.page.account': 'Account',
  'mytv.page.emailAddress': 'Email',
  'mytv.page.phoneNumberVerification': 'Phone Number Verification',
  'mytv.page.retryAfter': 'Retry After',
  'mytv.page.getVerificationCode': 'Get Verification Code',
  'mytv.page.emailNotice':
    'Note: Email address is associated with membership benefits. Once set, it cannot be changed. Changing your email account may affect purchased membership benefits.',
  'mytv.page.confirm': 'Confirm',
  'mytv.page.cancel': 'Cancel',
  'mytv.page.confirmLater': 'Confirm Later',
  'mytv.page.confirmEmailAddress': 'Confirm Email Address',
  'mytv.page.enterEmailAddress': 'Enter the Email Address you want to bind',
  'mytv.page.emailBindingSuccess': 'Email binding successful',
  'mytv.page.enterValidEmailAddress': 'Please enter a valid Email address',
  'mytv.page.enterVerificationCode': 'Please enter the verification code',
  'mytv.page.enterEmailAddressPrompt': 'Please enter your Email address',
  'mytv.page.bindEmail': 'Add email address',
};
